import axios from "axios";
import appStore from "./../store/appStore.js";

const baseService = async (
  url,
  body,
  cbSuccess = status => status,
  cbFail = status => status,
  options = {},
  method = "post"
) => {
  try {
    let response;
    if (method === "get") {
      response = await axios.get(url, {
        ...body,
        headers: {
          "Content-Type": "application/json",
          ...options.headers
        }
      });
    } else if (method === "post") {
      response = await axios.post(url, body, {
        ...options,
        headers: {
          "Content-Type": "application/json",
          ...options.headers
        }
      });
    }

    if (response.status === 200 || response.status === 201) {
      cbSuccess(response);
      return response;
    }
    throw new Error(response.status);
  } catch (err) {
    if (err.response && err.response.status === 401) {
      appStore.commit("auth/setIsSessionActive", false);
    }
    cbFail(err);
    return err;
  }
};

export default baseService;
